import useInitializeNewsTipFilter from './useInitializeNewsTipFilter'
export default useInitializeNewsTipFilter
